<template>
  <c-dropdown
    placement="bottom-end"
    :caret="false"
    in-nav
    class="c-header-nav-item d-md-down-none mx-2"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <c-header-nav-link>
        <c-icon name="cil-bell" />
        <c-badge shape="pill" color="danger">{{ itemsCount }}</c-badge>
      </c-header-nav-link>
    </template>

    <c-dropdown-header tag="div" class="text-center bg-light" style="min-width: 300px">
      <strong>You have {{ itemsCount }} notifications</strong>
    </c-dropdown-header>

    <c-dropdown-item>
      <c-icon name="cil-user-follow" class="text-success" />
      New user registered
    </c-dropdown-item>
    <c-dropdown-item>
      <c-icon name="cil-user-unfollow" class="text-danger" />
      User deleted
    </c-dropdown-item>
    <c-dropdown-item>
      <c-icon name="cil-chart-pie" class="text-info" />
      Sales report is ready
    </c-dropdown-item>
    <c-dropdown-item>
      <c-icon name="cil-basket" class="text-primary" />
      New client
    </c-dropdown-item>
    <c-dropdown-item>
      <c-icon name="cil-speedometer" class="text-warning" />
      Server overloaded
    </c-dropdown-item>
    <c-dropdown-header tag="div" class="text-center bg-light">
      <strong>Server</strong>
    </c-dropdown-header>
    <c-dropdown-item class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>CPU Usage</b></small>
      </div>
      <c-progress class="progress-xs" color="info" :value="25" />
      <small class="text-muted">348 Processes. 1/4 Cores.</small>
    </c-dropdown-item>
    <c-dropdown-item class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>Memory Usage</b></small>
      </div>
      <c-progress class="progress-xs" color="warning" :value="70" />
      <small class="text-muted">11444GB/16384MB</small>
    </c-dropdown-item>
    <c-dropdown-item class="d-block">
      <div class="text-uppercase mb-1">
        <small><b>SSD 1 Usage</b></small>
      </div>
      <c-progress class="progress-xs" color="danger" :value="90" />
      <small class="text-muted">243GB/256GB</small>
    </c-dropdown-item>
  </c-dropdown>
</template>
<script>
import Notifications from '@/views/components/Notifications';

export default {
  name: 'TheHeaderDropdownNotif',
  components: {
    Notifications,
  },
  data() {
    return { itemsCount: 5 };
  },
};
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>
